import { render } from "./ConfigurationOptionsFilter.vue?vue&type=template&id=80f2be3a&scoped=true"
import script from "./ConfigurationOptionsFilter.vue?vue&type=script&lang=js"
export * from "./ConfigurationOptionsFilter.vue?vue&type=script&lang=js"

import "./ConfigurationOptionsFilter.vue?vue&type=style&index=0&id=80f2be3a&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80f2be3a"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';import Ripple from 'quasar/src/directives/Ripple.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QItem,QToggle});qInstall(script, 'directives', {Ripple});
